import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import authenticationProvider from './authenticationProvider';
import ProviderManager from '../../provider/providerManager';
import helper from '../../utilities/helper';
import Config from '../../Config';
import otpAuthenticationStatus from '../../constans/otpAuthenticationStatus';
import {rolesKeys, fullLoginRoles, otpLoginRoles, otpExtendedLoginRoles} from '../../Components/Block/OTPLoginBlock/Assets/variables';
import {setItem} from '../localStorageUtils';
import {saveLoginCookie} from '../../utilities/cookieUtils';
import EpiContext from '@episerver/spa-core/Spa';
import {isOrgEmployeeLogin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
class AuthenticationError extends Error {
  constructor(message, code) {
    super(message);
    this.name = `Error ${code}`;
  }
}

export const loginUserAsync = createAsyncThunk('authentication/loginUserAsync', async (objData) => {
  try {
    const token = await authenticationProvider.getToken(objData.tempToken, true);
    if (!token || !token.access_token) {
      throw new Error('Invalid token');
    }
    const userDetails = await authenticationProvider.getUserDetails(token.access_token);
    const returnUrl = helper.getUrlParameter('returnUrl');
    const cancelUrl = helper.getUrlParameter('cancelUrl');

    const loginData = {
      isFullAuthenticated: true,
      isOtpExtendedAuthenticated: false,
      isOtpAuthenticated: false,
      isSilentOtpAuthenticated: false,
      token: token,
      clientID: Config.client_id,
      scope: Config.siteScope,
      returnUrl: returnUrl,
      cancelUrl: cancelUrl,
      userDetails: userDetails,
    };

    if (loginData.returnUrl) {
      authenticationProvider.saveLoginData(loginData);
    }

    return {loginData: loginData};
  } catch (e) {
    //TODO: handle error

    if (!e.message === 'Invalid token') {
      console.error('loginUserAsync', e);
    }
    throw e;
  }
});

export const loginOrgEmployeeAsync = createAsyncThunk('authentication/loginOrgEmployeeAsync', async (objData) => {
  try {
    const token = await authenticationProvider.getToken(objData.tempToken, false);
    const tokenDetails = await authenticationProvider.getTokenDetails(token.access_token);
    return {contactNumber: tokenDetails.LoginData.ContactValue, identity: tokenDetails.LoginData.IdNumber};
  } catch (e) {
    console.error('loginOrgEmployeeAsync', e);
    throw e;
  }
});

export const loginAboradMagicLinkUserAsync = createAsyncThunk('authentication/loginAboradMagicLinkUserAsync', async (objData) => {
  try {
    const token = await authenticationProvider.getToken(objData.tempToken, true);
    const userDetails = await authenticationProvider.getUserDetails(token.access_token, true, false);
    const returnUrl = helper.getUrlParameter('returnUrl');
    const cancelUrl = helper.getUrlParameter('cancelUrl');

    const loginData = {
      isFullAuthenticated: false,
      isOtpExtendedAuthenticated: false,
      isOtpAuthenticated: false,
      isSilentOtpAuthenticated: true,
      token: token,
      clientID: Config.client_id,
      scope: Config.siteScope,
      returnUrl: returnUrl,
      cancelUrl: cancelUrl,
      userDetails: userDetails,
    };

    if (loginData.returnUrl) {
      authenticationProvider.saveLoginData(loginData);
    }

    return {loginData: loginData};
  } catch (e) {
    //TODO: handle error
    console.error('loginAboradMagicLinkUserAsync', e);
    throw e;
  }
});

export const createOtpLogin = createAsyncThunk(
  'authentication/createOtpLogin',
  async ({phoneNumber, sendAsTextToSpeech = false, configName = 'OTP_SALE', otpOrigin = '', originProcess = ''}, thunkApi) => {
    try {
      const createOtpLoginResponse = await authenticationProvider.createOtpLogin(
        phoneNumber,
        sendAsTextToSpeech,
        configName,
        otpOrigin,
        originProcess,
      );

      if (
        (createOtpLoginResponse?.data?.Header?.ReturnCode !== 0 && createOtpLoginResponse?.data?.Header?.ReturnCode !== 31) ||
        !createOtpLoginResponse?.data?.Body
      ) {
        throw createOtpLoginResponse?.data?.Header?.ReturnCodeMessage;
      }

      const responseBody = createOtpLoginResponse?.data?.Body;
      return {
        phoneNumber: phoneNumber,
        ticketId: responseBody.otpTicketId,
        sentType: responseBody.sentType,
        isKosher: responseBody.isKosher,
        isSmsBlock: responseBody.isSmsBlock,
        termsInd: responseBody.termsInd,
        restrictedCodeRequired:
          createOtpLoginResponse?.data?.Header?.ReturnCode == 31 &&
          createOtpLoginResponse?.data?.Header?.ReturnCodeMessage == 'OTP_RESTRICT_CODE_REQUIRE',
      };
    } catch (error) {
      console.error('createOtpLogin', error);
      throw error;
    }
  },
);

export const createFullLoginStep1 = createAsyncThunk(
  'authentication/createFullLoginStep1',
  async ({phoneNumber, idNumber, digits, originProcess, customerEmail, loginType}, thunkApi) => {
    try {
      let createOtpLoginResponse = await ProviderManager.getProviderData('LoginStep1Full', [phoneNumber, idNumber, digits, originProcess, customerEmail, loginType]);
      return createOtpLoginResponse;
    } catch (error) {
      console.error('createFullLoginStep1', error);
      throw error;
    }
  },
);

export const createOtpLoginStep1 = createAsyncThunk(
  'authentication/createOtpLoginStep1',
  async ({phoneNumber="" ,isExtended, otpOrigin, originProcess ,loginType, genericFields}, thunkApi) => {
    try {
      var createOtpLoginResponse;
      if (isExtended) {
        createOtpLoginResponse = await ProviderManager.getProviderData('OtpExtendedStep1', [phoneNumber, otpOrigin, originProcess]);
      } else {
        createOtpLoginResponse = await ProviderManager.getProviderData('LoginStep1', [phoneNumber, '', otpOrigin, originProcess, loginType, genericFields]);
      }
      return createOtpLoginResponse;
    } catch (error) {
      throw error;
    }
  },
);



export const changeContactLogin = createAsyncThunk(
  'authentication/changeContactLogin',
  async (
    {phoneNumber, otpCode, guid, restrictCode, paymentDigits, changeContact, idNumber, contactCli, consumerIds, contactId},
    thunkApi,
  ) => {
    try {
      var res;
      var usedData;
      res = await ProviderManager.getProviderData('ChangeContactNumberLogin', [
        phoneNumber,
        otpCode,
        guid,
        restrictCode,
        idNumber,
        consumerIds,
        paymentDigits,
        changeContact,
        contactCli,
        contactId,
      ]);
      usedData = res.Body;

      if (!usedData.isSuccess) {
        return {isSuccess: false, codeError: usedData.codeError, errorMessage: usedData.resultMessage};
      }
      const token = usedData.extra.accessToken;
      const refreshToken = usedData.extra.refreshToken;
      if (token) {
        authenticationProvider.saveToken(token);
        if (refreshToken) {
          authenticationProvider.saveRefreshToken(refreshToken);
        }
      } else {
        throw {
          message: 'changeContactLogin failed. token not found!',
        };
      }
      const userDetails = await authenticationProvider.getUserDetails(token, false, false);
      const roleObj = determineLoginType(userDetails.LoginData.LoginType.toUpperCase());
      const loginData = {
        isFullAuthenticated: roleObj.isFullAuthenticated,
        isOtpAuthenticated: roleObj.isOtpAuthenticated,
        isOtpExtendedAuthenticated: roleObj.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: false,
        token: token,
        clientID: Config.client_id,
        scope: Config.siteScope,
        returnUrl: '',
        cancelUrl: '',
        userDetails: userDetails,
      };

      if (userDetails) {
        await authenticationProvider.saveLoginData(loginData);
        const storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', 'loginOtpSuccess');
      } else {
        throw {
          message: 'changeContactLogin failed. userDetails is empty!',
        };
      }
      return {loginData: loginData, isSuccess: true};
    } catch (error) {
      console.error('changeContactLogin', error);
      throw error;
    }
  },
);

export const createOtpLoginStep02 = createAsyncThunk(
  'authentication/createOtpLoginStep02',
  async (
    {
      phoneNumber,
      otpCode,
      guid,
      restrictCode,
      termsAccepted,
      checkPhoneNumber,
      loginType,
      idNumber,
      customerEmail,
      processType,
      otpOrigin,
      originProcess,
      genericFields,
    },
    thunkApi,
  ) => {
    try {
      var res;
      var usedData;
      if (loginType == rolesKeys.OTPEXTENDED) {
        res = await ProviderManager.getProviderData('OtpExtendedStep2', [
          phoneNumber,
          otpCode,
          guid,
          restrictCode,
          termsAccepted,
          checkPhoneNumber,
          loginType,
          otpOrigin,
          originProcess,
        ]);
        usedData = res.Body;
      } else {
        res = await authenticationProvider.createOtpLoginStep2(
          phoneNumber,
          otpCode,
          guid,
          restrictCode,
          termsAccepted,
          checkPhoneNumber,
          loginType,
          idNumber,
          customerEmail,
          processType,
          otpOrigin,
          originProcess,
          genericFields,
        );
        usedData = res.data.Body;
      }

      if (!usedData.isSuccess) {
        if (parseInt(usedData.codeError) == 74) {
          return {
            isSuccess: false,
            codeError: usedData.codeError,
            errorMessage: usedData.resultMessage,
            contactCli: usedData.extra.contact,
            consumersId: usedData.extra.consumers,
            contactId: usedData.extra.contactId,
          };
        } else {
          return {isSuccess: false, codeError: usedData.codeError, errorMessage: usedData.resultMessage};
        }
      }
      const token = usedData.extra.accessToken;
      const refreshToken = usedData.extra.refreshToken;
      if (token) {
        authenticationProvider.saveToken(token);
        if (idNumber && idNumber != '') {
          saveLoginCookie({token: usedData.extra.tokenDet});
        }
        if (refreshToken) {
          authenticationProvider.saveRefreshToken(refreshToken);
        }
      } else {
        throw {
          message: 'createOtpLoginStep02 failed. token not found!',
        };
      }
      const userDetails = await authenticationProvider.getUserDetails(token, false, false);
      const roleObj = determineLoginType(userDetails.LoginData.LoginType.toUpperCase());
      const loginData = {
        isFullAuthenticated: roleObj.isFullAuthenticated,
        isOtpAuthenticated: roleObj.isOtpAuthenticated,
        isOtpExtendedAuthenticated: roleObj.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: false,
        token: token,
        clientID: Config.client_id,
        scope: Config.siteScope,
        returnUrl: '',
        cancelUrl: '',
        userDetails: userDetails,
      };

      if (userDetails) {
        await authenticationProvider.saveLoginData(loginData);
        const storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', 'loginOtpSuccess');
      } else {
        throw {
          message: 'createOtpLoginStep02 failed. userDetails is empty!',
        };
      }
      return {loginData: loginData, isSuccess: true};
    } catch (error) {
      console.error('createOtpLoginStep02', error);
      throw error;
    }
  },
);
export const determineLoginType = (loginType) => {
  const isFull = fullLoginRoles.includes(loginType);
  const isOtp = otpLoginRoles.includes(loginType);
  const isExtended = otpExtendedLoginRoles.includes(loginType);
  return {
    isFullAuthenticated: isFull,
    isOtpAuthenticated: isOtp,
    isOtpExtendedAuthenticated: isExtended,
  };
};
export const createOtpLoginStep3 = createAsyncThunk(
  'authentication/createOtpLoginStep3',
  async ({phoneNumber, idNumber, scope, code, otpOrigin, originProcess}, thunkApi) => {
    try {
      const createOtpLoginResponse = await ProviderManager.getProviderData('LoginStep3', [
        phoneNumber,
        idNumber,
        scope,
        code,
        otpOrigin,
        originProcess,
      ]);
      const usedData = createOtpLoginResponse.Body;
      if (!usedData.isSuccess) {
        return {isSuccess: false, codeError: usedData.codeError};
      }
      if (usedData.extra.needsCode) {
        //setId(obj.idNumber);
        return {isSuccess: true, needsCode: true};
      }
      const token = usedData.extra.accessToken;
      const refreshToken = usedData.extra.refreshToken;
      if (token) {
        saveLoginCookie({token: usedData.extra.tokenDet});
        authenticationProvider.saveToken(token);
        if (refreshToken) {
          authenticationProvider.saveRefreshToken(refreshToken);
        }
      } else {
        throw {
          message: 'createOtpLoginStep3 failed. token not found!',
        };
      }

      const userDetails = await authenticationProvider.getUserDetails(token, false, true);

      const roleObj = determineLoginType(userDetails.LoginData.LoginType.toUpperCase());

      const loginData = {
        isFullAuthenticated: roleObj.isFullAuthenticated,
        isOtpAuthenticated: roleObj.isOtpAuthenticated,
        isOtpExtendedAuthenticated: roleObj.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: false,
        token: token,
        clientID: Config.client_id,
        scope: Config.siteScope,
        returnUrl: '',
        cancelUrl: '',
        userDetails: userDetails,
      };

      if (userDetails) {
        //await props.saveDumbLogin(loginData);
        await authenticationProvider.saveLoginData(loginData);
        const storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', 'loginOtpSuccess');
      } else {
        throw {
          message: 'createOtpLoginStep3 failed. userDetails is empty!',
        };
      }
      return {isSuccess: true, loginData: loginData};
    } catch (error) {
      console.error('createOtpLoginStep3', error);
      throw error;
    }
  },
);

export const resendOtpStep1 = createAsyncThunk('authentication/resendOtpStep1', async ({phoneNumber, isText, guid}, thunkApi) => {
  try {
    const createOtpLoginResponse = await ProviderManager.getProviderData('ResendLoginStep1', [phoneNumber, isText, guid]);
    return createOtpLoginResponse;
  } catch (error) {
    console.error('resendOtpStep1', error);
    throw error;
  }
});

export const refreshToken = createAsyncThunk('authentication/RefreshToken', async (data, thunkApi) => {
  try {
    const token = authenticationProvider.getRefreshToken();
    let res = await ProviderManager.getProviderData('RefreshToken', [token]);
    if (res.Body?.accessToken != null) {
      const newToken = res.Body.accessToken;
      const newRefreshToken = res.Body.refreshToken;
      authenticationProvider.saveToken(newToken);
      authenticationProvider.saveRefreshToken(newRefreshToken);
      res = await thunkApi.dispatch(reAuthenticateThunk(EpiContext.getCurrentPath()));
    }
    return res;
  } catch (error) {
    console.error('refreshToken', error);
    throw error;
  }
});

export const validateOtpLogin = createAsyncThunk(
  'authentication/validateOtpLogin',
  async ({code, restrictedCode, otpOrigin, originProcess}, thunkApi) => {
    const authenticationState = thunkApi.getState().authentication;
    const authenticationOtpState = authenticationState.otp;
    const {phoneNumber, ticketId} = authenticationOtpState;

    try {
      const validateOtpLoginResponse = await authenticationProvider.validateOtpLogin(
        phoneNumber,
        ticketId,
        code,
        restrictedCode,
        otpOrigin,
        originProcess,
      );

      if (validateOtpLoginResponse?.data?.Header?.ReturnCode !== 0 || !validateOtpLoginResponse?.data?.Body) {
        throw new AuthenticationError(
          validateOtpLoginResponse?.data?.Header?.ReturnCodeMessage,
          validateOtpLoginResponse?.data?.Header?.ReturnCode,
        );
      }

      const responseBody = validateOtpLoginResponse?.data?.Body;

      const token = responseBody.accessToken;
      const refreshToken = responseBody.refreshToken;
      if (token) {
        authenticationProvider.saveToken(token);
        if (refreshToken) {
          authenticationProvider.saveRefreshToken(refreshToken);
        }
      } else {
        throw {
          message: 'validateOtpLogin failed. token not found!',
        };
      }

      const userDetails = await authenticationProvider.getUserDetails(token, false, false);
      if (!userDetails?.LoginData) {
        throw {
          message: 'getUserDetails failed. Login data is empty',
        };
      }

      const loginData = {
        isFullAuthenticated: false,
        isOtpExtendedAuthenticated: false,
        isOtpAuthenticated: true,
        isSilentOtpAuthenticated: false,
        token: token,
        clientID: Config.client_id,
        scope: Config.siteScope,
        returnUrl: '',
        cancelUrl: '',
        userDetails: userDetails,
      };

      if (userDetails) {
        authenticationProvider.saveLoginData(loginData);
        const storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', 'loginSuccess');
      } else {
        throw {
          message: 'validateOtpLogin failed. userDetails is empty!',
        };
      }

      return {
        loginData: loginData,
      };
    } catch (error) {
      console.error('validateOtpLogin', error);
      throw error;
    }
  },
);

export const reAuthenticateThunk = createAsyncThunk('authentication/reAuthenticate', async (url, thunkApi) => {
  // default no Auth Result
  var result = {
    inProcess: false,
    isFullAuthenticated: false,
    isOtpExtendedAuthenticated: false,
    isOtpAuthenticated: false,
    isSilentOtpAuthenticated: false,
    token: {},
    userDetails: {},
  };

  try {
    // ignore re-auth while in kmsi process
    if (url && url.toLowerCase().indexOf('kmsi') > 0) {
      result.inProcess = true;
      return thunkApi.rejectWithValue(result);
    }

    const token = await authenticationProvider.getSavedToken();
    if (!token) {
      await authenticationProvider.clearAuthenticationData();
      return thunkApi.rejectWithValue(result);
    }
    const dataFromStorage = authenticationProvider.getLoginData();
    if (dataFromStorage.shouldContinueToSite != undefined && dataFromStorage.shouldContinueToSite != null) {
      console.log('data of continue: ', dataFromStorage.shouldContinueToSite);
      if (!dataFromStorage.shouldContinueToSite) {
        await authenticationProvider.clearAuthenticationData();
        return thunkApi.rejectWithValue(result);
      }
    }
    const callInit = dataFromStorage?.isOtpAuthenticated || dataFromStorage?.isOtpExtendedAuthenticated ? false : true;
    const userDetails = await authenticationProvider.getUserDetails(token, false, callInit);
    if (userDetails && userDetails.LoginData) {
      // const isOtp = userDetails.LoginData.LoginType.toUpperCase() === "OTP";
      const isOtp =
        userDetails.LoginData.LoginType.toUpperCase() === 'OTP' ||
        userDetails.LoginData.LoginType.toUpperCase() === 'NEWOTP' ||
        userDetails.LoginData.LoginType.toUpperCase() === 'SILENTLOGINOTP' ||
        userDetails.LoginData.LoginType.toUpperCase() == 'OTPSUBSCRIBER';

      const isExtended = userDetails.LoginData.LoginType.toUpperCase() === 'OTPEXTENDED';
      const roleObj = determineLoginType(userDetails.LoginData.LoginType.toUpperCase());
      result = {
        isFullAuthenticated: roleObj.isFullAuthenticated,
        isOtpExtendedAuthenticated: roleObj.isOtpExtendedAuthenticated,
        isOtpAuthenticated: roleObj.isOtpAuthenticated,
        isSilentOtpAuthenticated: userDetails.LoginData.LoginType.toUpperCase() === 'SILENTLOGINOTP',
        token: token,
        firstName: userDetails.LoginData.FirstName,
        lastName: userDetails.LoginData.LastName,
        IDNumber: userDetails.LoginData.IdNumber,
        IdfIdNumber: userDetails.LoginData.IdfIdNumber ?? '',
        contactNumber: userDetails.LoginData.ContactValue,
        role: userDetails.LoginData.ContactRole,
        isPrivate: authenticationProvider.isPravteUser(userDetails.LoginData.ContactRole),
        IsContactPerson: userDetails.LoginData.IsContactPerson,
        IsPrimaryContact: userDetails.LoginData.IsPrimaryContact,
        loginSubType: userDetails.LoginData.loginSubType,
        userName: userDetails.LoginData.UserName,
        dealerCode: userDetails.LoginData.DealerCode,
        Impersonate: userDetails.LoginData.Impersonate,
        IsFullFinance: userDetails.LoginData.IsFullFinance,
        OrgIdNumber: userDetails.LoginData.OrgIdNumber,
        RoleList: userDetails.RoleList,
        magicLinkParameters: userDetails.LoginData.MagicLinkParameters,
        PhoneSignStatus: userDetails.LoginData.PhoneSignStatus,
        CustomerEmail: userDetails.LoginData.CustomerEmail,
        OtpNumber: userDetails.LoginData.OtpNumber ?? '',
        OrganizationEmployee: userDetails.OrganizationEmployee ?? null,
      };
    } else {
      await authenticationProvider.clearAuthenticationData();
      return thunkApi.rejectWithValue(result);
    }

    return result;
  } catch (e) {
    await authenticationProvider.clearAuthenticationData();
    return thunkApi.rejectWithValue(result);
  }
});

export const getUserType = createAsyncThunk('userType/getUserType', async () => {
  try {
    const res = await ProviderManager.getProviderData('getUserType', []);
    if (res.Header.ReturnCode === 0) {
      return {UserType: res.Body};
    }
  } catch (err) {
    console.error('getUserType', err);
  }
});

const initialState = {
  loginStep: 'PHONE',
  error: {},
  loginData: {
    isFullAuthenticated: false,
    isOtpAuthenticated: false,
    isOtpExtendedAuthenticated: false,
    isSilentOtpAuthenticated: false,
    returnUrl: '',
    token: {},
    userDetails: {
      firstName: '',
      lastName: '',
    },
    shouldContinueToSite: true,
  },
  urlVariables: {
    error: '',
    variables: {},
  },
  redirectData: {},
  otp: {
    status: otpAuthenticationStatus.INITIALEIZED,
  },
  isPending: false,
  isAuthenticateFinish: false,
  formError: {
    otpCodeError: null,
    restrictedCodeError: null,
  },
  loginTemplate: '',
  forceExtended: false,
};

const step2SideEffects = (state, action) => {
  console.log(action.payload);
  if (action.payload.isSuccess) {
    console.log('succcessful!');
    const loginData = action.payload.loginData;
    const newData = {
      isFullAuthenticated: loginData.isFullAuthenticated,
      isOtpAuthenticated: loginData.isOtpAuthenticated,
      isOtpExtendedAuthenticated: loginData.isOtpExtendedAuthenticated,
      isSilentOtpAuthenticated: loginData.isSilentOtpAuthenticated,
      token: loginData.token,
      userDetails: {
        firstName: loginData.userDetails.LoginData.FirstName,
        lastName: loginData.userDetails.LoginData.LastName,
        IDNumber: loginData.userDetails.LoginData.IdNumber,
        contactNumber: loginData.userDetails.LoginData.ContactValue,
        role: loginData.userDetails.LoginData.ContactRole,
        isPrivate: authenticationProvider.isPravteUser(loginData.userDetails.LoginData.ContactRole),
        IsContactPerson: loginData.userDetails.LoginData.IsContactPerson,
        IsPrimaryContact: loginData.userDetails.LoginData.IsPrimaryContact,
        loginSubType: loginData.userDetails.LoginData.loginSubType,
        userName: loginData.userDetails.LoginData.UserName,
        dealerCode: loginData.userDetails.LoginData.DealerCode,
        Impersonate: loginData.userDetails.LoginData.Impersonate,
        IsFullFinance: loginData.userDetails.LoginData.IsFullFinance,
        RoleList: loginData.userDetails.RoleList,
        PhoneSignStatus: loginData.userDetails.LoginData.PhoneSignStatus,
        OrganizationEmployee: loginData.userDetails.OrganizationEmployee ?? null,
      },
      shouldContinueToSite: true,
    };
    console.log('new data', newData);
    state.loginData = newData;
    return state;
  } else if (action.payload.codeError == '1003') {
    state.formError.otpCodeError = 'קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש';
  } else if (action.payload.codeError == '1005') {
    state.formError.otpCodeError = 'רגע.. זה לא הקוד ששלחנו, שננסה שוב?';
  } else if (action.payload.codeError == '36') {
    state.formError.restrictedCodeError = 'יש טעות בקוד, שננסה שוב?';
  }
  return state;
};
const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: initialState,
  reducers: {
    setUrlVariables: (state, action) => {
      state.urlVariables = action.payload;
    },
    setLoginStage: (state, action) => {
      state.loginStep = action.payload;
    },
    setToken: (state, action) => {
      state.loginData.token = action.payload;
      return state;
    },
    clearError: {
      reducer(state, action) {
        state.error.errorCode = null;
        return state;
      },
    },
    setError: {
      reducer(state, action) {
        const {errorCode, pathName, cancelUrl, template} = action.payload;
        state.error.errorCode = errorCode;
        state.redirectData.pathName = pathName;
        state.redirectData.cancelUrl = cancelUrl;
        state.redirectData.template = template;
        return state;
      },
      prepare(errorCode, pathName, cancelUrl, template) {
        return {payload: {errorCode, pathName, cancelUrl, template}};
      },
    },
    saveToHistory: (state, action) => {
      return state;
    },
    forceExtendedOtp: (state, action) => {
      state.forceExtended = action.payload;
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    backHistory: (state, action) => {
      return state;
    },
    setContinueToSite: (state, action) => {
      state.loginData.shouldContinueToSite = action.payload;
      authenticationProvider.saveLoginData(state.loginData);
      return state;
    },
    saveLoginData: {
      reducer(state, action) {
        const {loginData} = action.payload;
        state.loginData = loginData;
        return state;
      },
      prepare(loginData) {
        return {
          payload: {
            isFullAuthenticated: loginData.isFullAuthenticated,
            isOtpAuthenticated: false,
            isOtpExtendedAuthenticated: false,
            isSilentOtpAuthenticated: false,
            token: loginData.token,
            userDetails: {
              firstName: loginData.userDetails.LoginData.FirstName,
              lastName: loginData.userDetails.LoginData.LastName,
              IDNumber: loginData.userDetails.LoginData.IdNumber,
              contactNumber: loginData.userDetails.LoginData.ContactValue,
              role: loginData.userDetails.LoginData.ContactRole,
              isPrivate: authenticationProvider.isPravteUser(loginData.userDetails.LoginData.ContactRole),
              IsContactPerson: loginData.userDetails.LoginData.IsContactPerson,
              IsPrimaryContact: loginData.userDetails.LoginData.IsPrimaryContact,
              loginSubType: loginData.userDetails.LoginData.loginSubType,
              userName: loginData.userDetails.LoginData.UserName,
              dealerCode: loginData.userDetails.LoginData.DealerCode,
              Impersonate: loginData.userDetails.LoginData.Impersonate,
              IsFullFinance: loginData.userDetails.LoginData.IsFullFinance,
              RoleList: loginData.userDetails.RoleList,
              OtpNumber: loginData.userDetails.LoginData.OtpNumber ?? '',
              OrganizationEmployee: loginData.userDetails.OrganizationEmployee ?? null,
            },
            shouldContinueToSite: true,
          },
        };
      },
    },
    saveDumbLogin: (state, action) => {
      const loginData = action.payload;
      const newData = {
        isFullAuthenticated: loginData.isFullAuthenticated,
        isOtpAuthenticated: loginData.isOtpAuthenticated,
        isOtpExtendedAuthenticated: loginData.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: loginData.isSilentOtpAuthenticated,
        token: loginData.token,
        userDetails: {
          firstName: loginData.userDetails.LoginData.FirstName,
          lastName: loginData.userDetails.LoginData.LastName,
          IDNumber: loginData.userDetails.LoginData.IdNumber,
          contactNumber: loginData.userDetails.LoginData.ContactValue,
          role: loginData.userDetails.LoginData.ContactRole,
          isPrivate: authenticationProvider.isPravteUser(loginData.userDetails.LoginData.ContactRole),
          IsContactPerson: loginData.userDetails.LoginData.IsContactPerson,
          IsPrimaryContact: loginData.userDetails.LoginData.IsPrimaryContact,
          loginSubType: loginData.userDetails.LoginData.loginSubType,
          userName: loginData.userDetails.LoginData.UserName,
          dealerCode: loginData.userDetails.LoginData.DealerCode,
          Impersonate: loginData.userDetails.LoginData.Impersonate,
          IsFullFinance: loginData.userDetails.LoginData.IsFullFinance,
          RoleList: loginData.userDetails.RoleList,
          OtpNumber: loginData.userDetails.LoginData.OtpNumber ?? '',
          OrganizationEmployee: loginData.userDetails.OrganizationEmployee ?? null,
        },
        shouldContinueToSite: true,
      };
      state.loginData = newData;
      return state;
    },
    getUserType(state, action) {
      return state;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
      return state;
    },
    setLoginTemplate: (state, action) => {
      state.loginTemplate = action.payload;
      return state;
    },
    resetAuth: (state) => initialState,
    resetLoginData: (state) => {
      state.loginData = initialState.loginData;
      return state;
    },
    updateUserDetails(state, action) {
      state.loginData.userDetails.firstName = action.payload.firstName;
      state.loginData.userDetails.lastName = action.payload.lastName;
      return state;
    },
    setMagicLinkParameters(state, action) {
      state.loginData.magicLinkParameters = action.payload;
    },
    setOtpError: (state, action) => {
      state.formError.otpCodeError = action.payload;
    },
    setRestrictedCodeError: (state, action) => {
      state.formError.restrictedCodeError = action.payload;
    },
    setAuthenticationName: (state, action) => {
      state.loginData.userDetails.firstName = action.payload.firstName;
      state.loginData.userDetails.lastName = action.payload.lastName;
      setItem('login_data', state.loginData);
    },
  },
  extraReducers: {
    [reAuthenticateThunk.fulfilled]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: action.payload.isFullAuthenticated,
        isOtpAuthenticated: action.payload.isOtpAuthenticated,
        isOtpExtendedAuthenticated: action.payload.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: action.payload.isSilentOtpAuthenticated,
        token: action.payload.token,
        userDetails: {
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          IDNumber: action.payload.IDNumber,
          IdfIdNumber: action.payload.IdfIdNumber,
          contactNumber: action.payload.contactNumber,
          role: action.payload.role,
          isPrivate: authenticationProvider.isPravteUser(action.payload.role),
          IsContactPerson: action.payload.IsContactPerson,
          IsPrimaryContact: action.payload.IsPrimaryContact,
          loginSubType: action.payload.loginSubType,
          userName: action.payload.userName,
          dealerCode: action.payload.DealerCode,
          Impersonate: action.payload.Impersonate,
          IsFullFinance: action.payload.IsFullFinance,
          Ban: action.payload.Ban,
          RoleList: action.payload.RoleList,
          OrgIdNumber: action.payload.OrgIdNumber,
          PhoneSignStatus: action.payload.PhoneSignStatus,
          CustomerEmail: action.payload.CustomerEmail,
          OtpNumber: action.payload.OtpNumber ?? '',
          OrganizationEmployee: action.payload.OrganizationEmployee ?? null,
        },
        magicLinkParameters: action.payload.magicLinkParameters,
        shouldContinueToSite: true,
      };
      state.isPending = false;
      state.isAuthenticateFinish = true;
      return state;
    },
    [reAuthenticateThunk.pending]: (state) => {
      state.isPending = true;
    },
    [reAuthenticateThunk.rejected]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: false,
        isOtpAuthenticated: false,
        isOtpExtendedAuthenticated: false,
        isSilentOtpAuthenticated: false,
        token: {},
        userDetails: {
          firstName: '',
          lastName: '',
          IDNumber: '',
          contactNumber: '',
          role: '',
        },
      };
      state.isPending = false;
      state.isAuthenticateFinish = true;
      return state;
    },
    [loginUserAsync.fulfilled]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: action.payload.loginData.isFullAuthenticated,
        isOtpAuthenticated: action.payload.loginData.isOtpAuthenticated,
        isOtpExtendedAuthenticated: action.payload.loginData.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: action.payload.loginData.isSilentOtpAuthenticated,
        token: action.payload.loginData.token,
        userDetails: {
          firstName: action.payload.loginData.userDetails.LoginData.FirstName,
          lastName: action.payload.loginData.userDetails.LoginData.LastName,
          IDNumber: action.payload.loginData.userDetails.LoginData.IdNumber,
          contactNumber: action.payload.loginData.userDetails.LoginData.ContactValue,
          role: action.payload.loginData.userDetails.LoginData.ContactRole,
          isPrivate: authenticationProvider.isPravteUser(action.payload.loginData.userDetails.LoginData.ContactRole),
          IsContactPerson: action.payload.loginData.userDetails.LoginData.IsContactPerson,
          IsPrimaryContact: action.payload.loginData.userDetails.LoginData.IsPrimaryContact,
          loginSubType: action.payload.loginData.userDetails.LoginData.loginSubType,
          userName: action.payload.loginData.userDetails.LoginData.UserName,
          dealerCode: action.payload.loginData.userDetails.LoginData.DealerCode,
          Impersonate: action.payload.loginData.userDetails.LoginData.Impersonate,
          IsFullFinance: action.payload.loginData.userDetails.LoginData.IsFullFinance,
          CustomerEmail: action.payload.loginData.userDetails.LoginData.CustomerEmail,
          OrganizationEmployee: action.payload.loginData.userDetails.OrganizationEmployee ?? null,
        },
        shouldContinueToSite: true,
      };
      state.isPending = false;
      return state;
    },
    [loginUserAsync.pending]: (state) => {
      state.isPending = true;
    },
    [loginUserAsync.rejected]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: false,
        isOtpAuthenticated: false,
        isOtpExtendedAuthenticated: false,
        isSilentOtpAuthenticated: false,
        token: {},
        userDetails: {
          firstName: '',
          lastName: '',
          IDNumber: '',
          contactNumber: '',
          role: '',
        },
      };
      state.isPending = false;
      return state;
    },
    [loginAboradMagicLinkUserAsync.fulfilled]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: action.payload.loginData.isFullAuthenticated,
        isOtpAuthenticated: action.payload.loginData.isOtpAuthenticated,
        isOtpExtendedAuthenticated: action.payload.loginData.isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated: action.payload.loginData.isSilentOtpAuthenticated,
        token: action.payload.loginData.token,
        userDetails: {
          firstName: action.payload.loginData.userDetails.LoginData.FirstName,
          lastName: action.payload.loginData.userDetails.LoginData.LastName,
          IDNumber: action.payload.loginData.userDetails.LoginData.IdNumber,
          contactNumber: action.payload.loginData.userDetails.LoginData.ContactValue,
          role: action.payload.loginData.userDetails.LoginData.ContactRole,
          isPrivate: authenticationProvider.isPravteUser(action.payload.loginData.userDetails.LoginData.ContactRole),
          IsContactPerson: action.payload.loginData.userDetails.LoginData.IsContactPerson,
          IsPrimaryContact: action.payload.loginData.userDetails.LoginData.IsPrimaryContact,
          loginSubType: action.payload.loginData.userDetails.LoginData.loginSubType,
          userName: action.payload.loginData.userDetails.LoginData.UserName,
          dealerCode: action.payload.loginData.userDetails.LoginData.DealerCode,
          Impersonate: action.payload.loginData.userDetails.LoginData.Impersonate,
          IsFullFinance: action.payload.loginData.userDetails.LoginData.IsFullFinance,
          OrganizationEmployee: action.payload.loginData.userDetails.OrganizationEmployee ?? null,
        },
        shouldContinueToSite: true,
      };
      state.isPending = false;

      return state;
    },
    [loginAboradMagicLinkUserAsync.pending]: (state) => {
      state.isPending = true;
    },
    [loginAboradMagicLinkUserAsync.rejected]: (state, action) => {
      state.loginData = {
        isFullAuthenticated: false,
        isOtpAuthenticated: false,
        isOtpExtendedAuthenticated: false,
        isSilentOtpAuthenticated: false,
        token: {},
        userDetails: {
          firstName: '',
          lastName: '',
          IDNumber: '',
          contactNumber: '',
          role: '',
        },
      };
      state.isPending = false;

      return state;
    },
    [createOtpLogin.pending]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.CREATE_OTP_PENDING;
      state.otp.error = '';
    },
    [createOtpLogin.fulfilled]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.CREATE_OTP_SUCCESS;
      state.otp.error = '';
      Object.assign(state.otp, action.payload);
    },
    [createOtpLogin.rejected]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.CREATE_OTP_FAIL;
      state.otp.error = action.error;
    },
    [validateOtpLogin.pending]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.VALIDATE_OTP_PENDING;
      state.otp.error = '';
    },
    [validateOtpLogin.fulfilled]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.VALIDATE_OTP_SUCCESS;
      state.loginData = {
        isFullAuthenticated: false,
        isOtpAuthenticated: true,
        isOtpExtendedAuthenticated: false,
        isSilentOtpAuthenticated: false,
        token: action.payload.loginData.token,
        userDetails: {
          firstName: action.payload.loginData.userDetails.LoginData.FirstName,
          lastName: action.payload.loginData.userDetails.LoginData.LastName,
          IDNumber: action.payload.loginData.userDetails.LoginData.IdNumber,
          contactNumber: action.payload.loginData.userDetails.LoginData.ContactValue,
          role: action.payload.loginData.userDetails.LoginData.ContactRole,
          isPrivate: authenticationProvider.isPravteUser(action.payload.loginData.userDetails.LoginData.ContactRole),
          IsContactPerson: action.payload.loginData.userDetails.LoginData.IsContactPerson,
          IsPrimaryContact: action.payload.loginData.userDetails.LoginData.IsPrimaryContact,
          loginSubType: action.payload.loginData.userDetails.LoginData.loginSubType,
          userName: action.payload.loginData.userDetails.LoginData.UserName,
          dealerCode: action.payload.loginData.userDetails.LoginData.DealerCode,
          Impersonate: action.payload.loginData.userDetails.LoginData.Impersonate,
          IsFullFinance: action.payload.loginData.userDetails.LoginData.IsFullFinance,
          OrganizationEmployee: action.payload.loginData.userDetails.OrganizationEmployee ?? null,
        },
        shouldContinueToSite: true,
      };
    },

    [validateOtpLogin.rejected]: (state, action) => {
      state.otp.status = otpAuthenticationStatus.VALIDATE_OTP_FAIL;
      state.otp.error = action.error;
    },
    [createOtpLoginStep02.fulfilled]: (state, action) => {
      return step2SideEffects(state, action);
    },
    [changeContactLogin.fulfilled]: (state, action) => {
      return step2SideEffects(state, action);
    },
    [createOtpLoginStep3.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        const loginData = action.payload.loginData;
        const newData = {
          isFullAuthenticated: loginData.isFullAuthenticated,
          isOtpAuthenticated: loginData.isOtpAuthenticated,
          isOtpExtendedAuthenticated: loginData.isOtpExtendedAuthenticated,
          isSilentOtpAuthenticated: loginData.isSilentOtpAuthenticated,
          token: loginData.token,
          userDetails: {
            firstName: loginData.userDetails.LoginData.FirstName,
            lastName: loginData.userDetails.LoginData.LastName,
            IDNumber: loginData.userDetails.LoginData.IdNumber,
            contactNumber: loginData.userDetails.LoginData.ContactValue,
            role: loginData.userDetails.LoginData.ContactRole,
            isPrivate: authenticationProvider.isPravteUser(loginData.userDetails.LoginData.ContactRole),
            IsContactPerson: loginData.userDetails.LoginData.IsContactPerson,
            IsPrimaryContact: loginData.userDetails.LoginData.IsPrimaryContact,
            loginSubType: loginData.userDetails.LoginData.loginSubType,
            userName: loginData.userDetails.LoginData.UserName,
            dealerCode: loginData.userDetails.LoginData.DealerCode,
            Impersonate: loginData.userDetails.LoginData.Impersonate,
            IsFullFinance: loginData.userDetails.LoginData.IsFullFinance,
            RoleList: loginData.userDetails.RoleList,
            OrganizationEmployee: loginData.userDetails.OrganizationEmployee ?? null,
          },
          shouldContinueToSite: true,
        };
        state.loginData = newData;
      }
      return state;
    },
  },
});

export const {
  setUrlVariables,
  setError,
  saveDumbLogin,
  saveLoginData,
  clearError,
  resetAuth,
  resetLoginData,
  setRedirectUrl,
  setLoginTemplate,
  updateUserDetails,
  setMagicLinkParameters,
  setToken,
  setLoginStage,
  saveToHistory,
  setOtpError,
  setRestrictedCodeError,
  setContinueToSite,
  setAuthenticationName,
  clearHistory,
  backHistory,
  forceExtendedOtp,
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
